/**
 * @classdesc - カウント表示のアニメーションClass
 */

import gsap from 'gsap';


export default class Counter{
    
    constructor(){
        // 取得したハッシュカウントの数値
        this.counterNum = BOCCHI.hashCount.get();
    }


    countup(){
        this._animateCounter();
    }


    _animateCounter() {
        const counterNumStr = String(this.counterNum).padStart(6, '0');
        const counterElems = document.querySelectorAll('.js-counter_num');

        counterElems.forEach((elem, index) => {
            const targetNum = parseInt(counterNumStr[index], 10);
            let obj = {value: 0};

            gsap.to(obj, {
                value: targetNum, duration: 1.0, ease: 'power2.out',
                onUpdate: () => {
                    elem.setAttribute('data-num', Math.round(obj.value));
                }
            });
        });

        gsap.to('.fv__counter__main', {duration:0.25, delay:1.2, scale:1.15, yoyo:true, repeat:1, ease:'power2.out'});
    }
}
